import { render, staticRenderFns } from "./siderbar.vue?vue&type=template&id=8dbb82b0&"
import script from "./siderbar.vue?vue&type=script&lang=js&"
export * from "./siderbar.vue?vue&type=script&lang=js&"
import style0 from "./siderbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports